<template>
  <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Manage Accounts</h5>
              <div class="float-right">
                <button type="button" @click="openAddForm()" class="btn btn-sm btn-success">ADD</button>
                <button type="button" class="close"  @click="$emit('close')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="modal-body">
               <div class="row" v-if="isAddOrEdit">
                <div class="col-md-6">
                  <label for="accountno required">Account No *</label>
                  <div class="input-group mb-3">
                    <input 
                    :disabled="isEdit" 
                    type="text"
                    maxlength="15" 
                    class="form-control" 
                    id="accountno" 
                    placeholder="Enter Account No" 
                    @keypress="isAlphanumeric($event)"
                    v-model="accountNumber">
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="accountno">Type</label>
                  <div class="input-group mb-3">
                     <select class="form-control"  v-model="accountType" >
                        <option value="Cash">Cash</option>
                        <option value="Margin">Margin</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="accountno">Ims Ticket Spread</label>
                  <div class="input-group mb-3">
                    <input 
                    type="number"
                    maxlength="15" 
                    class="form-control" 
                    id="accountno" 
                    placeholder="Spread" 
                    v-model="ticketSpread">
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="accountno">Bid Accumulator Ticket Spread</label>
                  <div class="input-group mb-3">
                    <input 
                    type="number"
                    maxlength="15" 
                    class="form-control" 
                    id="accountno" 
                    placeholder="Spread" 
                    v-model="bwTicketSpread">
                  </div>
                </div>
                <div class="col-md-3" v-if="isMoneyLine">
                  <label for="accountno">PMP</label>
                  <div class="input-group mb-3">
                     <select class="form-control"  v-model="PMP" >
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3" v-if="isMoneyLine">
                  <label for="accountno">FBSI Short Name</label>
                  <div class="input-group mb-3">
                      <input  type="text" class="form-control" id="accountno" placeholder="FBSI Short Name" v-model="FBSIShortName">
                  </div>
                </div>
                <div class="col-md-6" v-if="isMoneyLine">
                  <label for="accountno">Note</label>
                  <div class="input-group mb-3">
                    <textarea class="form-control" v-model="note" rows="2" maxlength="450"></textarea>
                  </div>
                </div>
              </div>
              <p  v-if="errors.length && isAddOrEdit">
                  <ul>
                    <li v-for="error in errors" v-bind:key="error" class="alert alert-danger" role="alert">{{error}}</li>
                  </ul>
              </p>
              <div  v-if="isAddOrEdit" class="modal-footer">
                  <button class="btn btn-light"  @click="closeAddForm();" type="button">Cancel</button>
                  <button v-if="!isEdit" class="btn btn-primary" type="button" @click="customerAddAccount()">ADD ACCOUNT</button>
                  <button v-if="isEdit" class="btn btn-primary" type="button" @click="customerEditAccount()">UPDATE ACCOUNT</button>
                </div>
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="sort text-center">ACCOUNT</th>
                    <th scope="col" class="sort text-center">TYPE </th>
                    <th scope="col" class="sort text-center">IMS <br> TICKET SPREAD </th>
                    <th scope="col" class="sort text-center">BID ACCUMULATOR <br>TICKET SPREAD </th>
                    <th scope="col" class="sort text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="customerAccounts.length == 0 && !loading">
                      <td><p class="nodata">No data available</p>
                      </td>
                  </tr>
                  <tr v-for="account in customerAccounts" :key="account.accountNumber">
                    <td class="text-center text-primary p-0"><span class="cusips">{{account.accountNumber}}</span></td>
                    <td class="text-center">{{account.accountType}}</td>
                    <td class="text-center">{{account.ticketSpread}}</td>
                    <td class="text-center">{{account.bwTicketSpread}}</td>
                    <td class="text-center">
                      <div class="d-inline-flex"> 
                          <div class="dropdown">
                              <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <i class="fas fa-ellipsis-v"></i>
                              </button>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                  <button @click="editAccount(account)" class="dropdown-item" type="button">Edit</button>
                                  <button @click="openOfferingModal(account)"   class="dropdown-item" type="button">Offerings</button>
                                  <button @click="openSpreadModal(account)"   class="dropdown-item" type="button">Spread</button>
                                  <button @click="deleteAccount(account)" class="dropdown-item del" type="button">Delete</button>
                              </div>
                          </div>
                      </div>   
                      <!-- <button class="btn ibtn btn-outline-success" @click="editAccount(account)" title="Edit"><i class="fas fa-pencil-alt"></i></button>
                      <button @click="openOfferingModal(account)"  class="btn ibtn btn-outline-success" title="Offerings"><i class="fa fa-hand-holding-usd"></i></button>
                      <button @click="deleteAccount(account)" class="btn ibtn btn-outline-danger" title="Delete"><i class="far fa-trash-alt"></i></button> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      <accountoffering
        v-if="openAccountOfferingModal"
        v-bind:accountData="accountData"
        @close="openAccountOfferingModal = false"
      ></accountoffering>
      <spread 
        v-if="spreadModal"
        v-bind:accountData="accountData"
        @close="spreadModal = false"
      ></spread> 
  </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    import accountoffering from "./ImsAccountOfferings";
    import spread from "./ImsSpreadModal"
    export default {
        name: 'customerAddAccountmodal',
        components :{
            accountoffering,
            spread
        },
        props: ['customerData','isMoneyLine'],
        data() {
            return {
                loading : false,
                // error: null,
                errors: [],
                customerAccounts : [],
                accountNumber : null,
                accountType : "Cash",
                isAddOrEdit : false,
                isEdit : false,
                selectedAccount : null,
                openAccountOfferingModal : false,
                spreadModal : false,
                accountData : null,
                FBSIShortName : "",
                PMP : "YES",
                note : "",
                ticketSpread : null,
                bwTicketSpread : null

                
            };
        },
        methods: {
          openOfferingModal(account){
            this.accountData = account
            this.openAccountOfferingModal = true;
          },
          openSpreadModal(account){
            this.accountData = account
            this.spreadModal = true;
          },
          openAddForm(){
            this.isAddOrEdit = true;
            this.isEdit = false;
            this.accountNumber = null;
            this.ticketSpread = null;
            this.bwTicketSpread = null;
            this.accountType = "Cash";
            this.errors = [];
          },
          closeAddForm(){
            this.isAddOrEdit = false;
            this.isEdit = false;
            this.accountNumber = null;
            this.ticketSpread = null;
            this.bwTicketSpread = null;
            this.accountType = "Cash";
            this.errors = [];

          },
          editAccount(account){
            this.selectedAccount = account;
            this.accountNumber = account.accountNumber;
            this.ticketSpread = account.ticketSpread;
            this.bwTicketSpread = account.bwTicketSpread;
            this.accountType = account.accountType;
            this.isAddOrEdit = true;
            this.isEdit = true;
          }, 
          customerEditAccount(){
            this.loading = true;
            this.errors = [];

             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            if(!this.accountNumber){
              this.errors.push("Account number is required.");
              this.loading = false;
              return false;
            }
            this.$http
            .put(
              config.baseUrlBidSide +
                "/account/mapping-update",
                {"id":this.selectedAccount.accountMappingId,"account": this.accountNumber,"accountType":this.accountType,"ticketSpread" : this.ticketSpread,"bwTicketSpread" : this.bwTicketSpread},
                auth
            )
            .then(() => {
              this.loading = false;
              this.$alert("Account Updated")
              this.closeAddForm();
              this.selectedAccount = null;
              this.getCustomerAccounts();
              

            })
          },  
          getCustomerAccounts(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/customer/"+this.customerData.id,
                auth
            )
            .then(result => {
              this.customerAccounts = result.data;
              this.loading = false;
            })
          },
          customerAddAccount(){
            this.loading = true;
            this.errors = [];

            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            if(!this.accountNumber){
              this.errors.push("Account number is required")
              this.loading = false;
              return false;
            }
            if(this.accountNumber.length < 6){
              this.errors.push("Account number length should be between 6 to 10 characters. ")
              this.loading = false;
              return false;
            }
            this.accountNumber = this.accountNumber.toUpperCase();
            this.$http
            .post(
              config.baseUrlBidSide +
                "/customer/add-account",
                { "accountAddDto": [{"customerId":this.customerData.id,"ticketSpread" : this.ticketSpread,"bwTicketSpread" : this.bwTicketSpread,"account": this.accountNumber,"accountType":this.accountType,"status":"ACTIVE"}]},
                auth
            )
            .then((result) => {
              this.loading = false;
              if(result.data != 'OK'){
                this.$alert(result.data)
              }
              this.accountNumber = null;
              this.getCustomerAccounts();
              this.isAddOrEdit = false;

            })
          },
          deleteAccount(account){
             var message = "Are you sure you want to delete this account?";

            this.$confirm(message,"Delete account","",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
              this.loading = true;
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
              };
              this.$http
              .put(
                config.baseUrlBidSide +
                  "/customer/account-status",
                  {"traderCustomerId":this.customerData.id,"accountMappingId":account.accountMappingId,"status":"DEACTIVE"},
                  auth
              )
              .then((result) => {
                if(result.data != "You can't delete this customer as it is part of an inventory"){
                  this.accountNumber = null;
                  this.getCustomerAccounts();
                }else{
                  this.$alert("You can't delete this account as it is part of an inventory");
                }
                this.loading = false;
              })
            });
          }
        },
        mounted() {
          this.getCustomerAccounts();
        }
    };
    </script>